import './plugins';

export default {};